import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoFornecedor, ServicoMarca } from '../../servicos/srv.produto';

@Component({
  selector: 'tsv2-mrc-adicionar',
  templateUrl: './adicionar.component.html',
  providers: [ ServicoMsg, ServicoFornecedor, ServicoMarca ]
})
export class MarcaAdicionarComponent implements OnInit {
  exibirBarra: boolean = true;
  
  fornecedores: any;
  psq: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    // private spinner: NgxSpinnerService,
    private servicoFornecedor: ServicoFornecedor,
    private servicoMsg: ServicoMsg,
    private servicoMarca: ServicoMarca
  ) { }

  ngOnInit() {
    // this.spinner.show();
    this.servicoFornecedor.listarFornecedores({}).subscribe(rsp => {
      this.fornecedores = rsp.lista;
      // this.spinner.hide();
    }, (err) => {
      // this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

  adicionarMarca(frmValues){
    // this.spinner.show();
    this.servicoMarca.adicionarMarca(frmValues).subscribe(id => {
      let url = '/marca/visualizar/' + id;
      // this.spinner.hide();
      this.servicoMsg.exibeSucesso('Criada!', 'Marca criada com sucesso!').then(r1 => {
        if (r1.success){
          this.router.navigate([url]);
        }
      }, (err: any) => {
        // this.spinner.hide();
        this.servicoMsg.exibeErro(err).then(r1 => {});
      });
    }, (err: any) => {
      // this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
